import Image from 'next/image';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React from 'react';
import { Container } from 'react-bootstrap';
import ReactHtmlParser from 'react-html-parser';
import { ButtonBase } from '../Forms';
import SectionBox from '../SectionBox/SectionBox';
import { HtmlBlockStyled } from './HtmlBlockStyled';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';

const HtmlBlock = ({ type, data }) => {
  const router = useRouter();
  const generateURL = useNavigationURL();

  if (type === 'Custom Block') {
    return (
      <HtmlBlockStyled>
        <SectionBox customClass="section-title" customOuterClass="pb-4">
          <div className={`custom-block ${data?.imagePosition && data?.imagePosition !== 'Right' ? 'left' : ''}`}>
            <div>
              <h1 className="custom_block_title">{data.title}</h1>
              {ReactHtmlParser(data?.description)}
              {data.buttonName && (
                <ButtonBase
                  size="sm"
                  variant="primary"
                  outerCustomClass="custom-button"
                  text={data.buttonName}
                  onClick={() => {
                    router.push({
                      pathname: generateURL(data?.buttonLinkWeb),
                    });
                  }}
                />
              )}
            </div>
            {data.imageWeb && (
              <div className="image-outer">
                <Image
                  src={data.imageWeb}
                  width="100%"
                  height="100%"
                  alt={data?.alttext}
                  className="image-wrapper"
                  onClick={() => {
                    router.push({
                      pathname: generateURL(data?.imageWebLink),
                    });
                  }}
                />
              </div>
            )}
          </div>
        </SectionBox>
      </HtmlBlockStyled>
    );
  }
  return <Container>{ReactHtmlParser(data?.description)} </Container>;
};

HtmlBlock.propTypes = {
  data: PropTypes.object,
  type: PropTypes.string,
};

HtmlBlock.defaultProps = {
  type: '',
  data: {},
};
export default HtmlBlock;
